import type { EntryRemoval } from "./provenance.model.ts";

/**
 * Dropping a draft, or withdrawing an entry from the record.
 *
 * Its own control rather than a passenger in the verification panel, which is
 * where it used to live behind a prop comment apologising for it. Unmaking an
 * entry is not a position anybody takes on it.
 *
 * The note is the whole argument for the warning being here rather than at the
 * top of every recorded entry: what withdrawing does to what is already on the
 * record is a fact about this button, and only somebody who can press it needs
 * to be told it.
 */
export function ProvenanceEntryRemoval({
  removal,
  onRemove,
}: {
  removal: EntryRemoval;
  onRemove: () => void;
}) {
  return (
    <div className="provenance__removal">
      {removal.note !== null && <p className="provenance__help">{removal.note}</p>}

      <button type="button" className="provenance__withdraw" onClick={onRemove}>
        {removal.label}
      </button>
    </div>
  );
}
